import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './BaseBackButton.css';

const BaseBackButton = ({onClick, buttonLabel, buttonId}) => {
    return (
        <div className={s.component}>
            <nav className={s.container}>
                <button
                    type="button"
                    id={"back-button-" + ((buttonId === null || buttonId === undefined || buttonId.trim() === "") ? buttonLabel : buttonId)}
                    aria-label={"Back Button to " + buttonLabel}
                    className={cx(s.backButton)}
                    onClick={onClick}
                />
                <h1 className={s.label} onClick={onClick}>{buttonLabel}</h1>
            </nav>
        </div>
    );
};

BaseBackButton.propTypes = {
    onClick: PropTypes.func,
    buttonLabel: PropTypes.string.isRequired,
};

export default BaseBackButton;


// WEBPACK FOOTER //
// ./src/components/BaseBackButton/BaseBackButton.js